import { useTranslation } from "react-i18next";

const FOOTER_OFFICES = [
  {
    name: "Philippines Operations Center",
    address:
      "Address: 3rd Floor AYO Building, Magsaysay Ave. Baguio City, Philippines",
    contact: "Email: John@btbpbpo.com",
  },
  {
    name: "Europe Operations Center",
    address:
      'Address: Tbilisi, SABURTALO, 1a Saakadze II pass, business centre "Atrium"',
    contact: "Email: Jack@btbpbpo.com",
  },
];

export default function Footer() {
  const { t } = useTranslation();

  return (
    <div className="bg-[#121416] relative w-full pt-[22px]">
      <div className="max-w-[1200px] mx-auto px-4 md:px-5">
        <div className="flex flex-col md:block">
          {FOOTER_OFFICES.map((office, index) => (
            <div
              key={index}
              className="mt-6 md:mt-7.5 text-left md:inline-block w-full md:odd:w-[55%] md:even:w-[45%]"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              <h2 className="text-white font-bold pb-3 text-base">
                {office.name}
              </h2>
              <p
                className=" leading-6 text-[#878b92]"
                dangerouslySetInnerHTML={{ __html: office.address }}
              />
              <p
                className=" leading-6 text-[#878b92]"
                dangerouslySetInnerHTML={{ __html: office.contact }}
              />
            </div>
          ))}
        </div>
        <div className="w-full border-t border-[#2e3032] mt-10 md:mt-12 leading-5 text-center py-5">
          <span className="block text-[#888c92] text-sm">
            {t("footer.copyright", "")}
          </span>
        </div>
      </div>
    </div>
  );
}
